import styled from 'styled-components';

export default styled.div`
  cursor: pointer;
  .user-avatar {
    margin-top: -12px;
  }
`;
